module.exports = __webpack_public_path__ + "img/hair_back_female_very_short_mask.6c9a2a10.png";